
import { IconSuccess } from '@/public/assets/icons/IconSuccess';
import styles from './Alert.module.scss';
import { AlertProps } from './types';
import { IconInfo } from '@/public/assets/icons/IconInfo';
import { IconWarning } from '@/public/assets/icons/IconWarning';
import { IconError } from '@/public/assets/icons/IconError';

export function Alert({ status, title, action, children }: AlertProps) {
  return (
    <div className={styles.alert_main} data-status={status} data-alert="alert">
      <div className={styles.alert_toolbar}>
        <div className={styles.alert_title}>
          <div className={styles.alert_icon}>
            {status === 'info' && <IconInfo />}
            {status === 'warning' && <IconWarning />}
            {status === 'error' && <IconError />}
            {status === 'success' && <IconSuccess />}
          </div>

          <span className={styles.alert_label}>{title}</span>
        </div>

        {action && <div className={styles.alert_action}>{action}</div>}
      </div>

      {children && <div className={styles.alert_content}>{children}</div>}
    </div>
  );
}
